import { useEffect } from 'react';
import { loadUserTrackingData } from '@pegasus/tracker';

import { tracker } from '../helpers';

export const useTrackData = (attributes: Record<string, any> = {}) =>
    useEffect(() => {
        const sendTrackEvent = async () => {
            const trackResponse = await loadUserTrackingData();
            const generatedUrl = window.location.pathname;
            tracker.track('TRACK_DATA', { ...trackResponse, generatedUrl, ...attributes });
        };
        sendTrackEvent();
    }, [window.location.pathname]);
